export default __webpack_public_path__ + "static/media/cross-purple.32616732.svg";